export default {
  Admin: 'API.Legal.Admin',
  User: 'API.Legal.User',
};
